import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StatusRequestEnum } from '@shared/enum/status-request.enum';

@Component({
  selector: 'app-request-list-card',
  templateUrl: './request-list-card.component.html',
  styleUrls: ['./request-list-card.component.scss']
})
export class RequestListCardComponent  implements OnInit {
  @Input() containerTypes: any;
  @Input() destinationInfo: any;
  @Input() goods: any;
  @Input() createdAt: string;
  @Input() id: number;
  @Input() originationInfo: any;
  @Input() serviceTypeId: number;
  @Input() user: any;
  @Input() responseCount: any;
  @Input() requestStatus: any;

  EXPIRED = StatusRequestEnum.EXPIRED;
  PENDING = StatusRequestEnum.PENDING;
  IN_PROGRESS = StatusRequestEnum.IN_PROGRESS;
  CLOSED = StatusRequestEnum.CLOSED;
  IN_CONTRACT = StatusRequestEnum.IN_CONTRACT;
  IS_EXTENDABLE = StatusRequestEnum.IS_EXTENDABLE;

  constructor(public router: Router) { }

  ngOnInit(): void {
  }

}
